<template>
	<div class="container">
		<div class="header"><img :src="$store.state.config.header" class="img"></div>
		<div class="content">
			<div class="main-body">
				<div class="top-bar" :style="{backgroundColor:$store.state.config.title_color}">{{title}}</div>
				<div class="main-wrapper t-block">
					<div class="main-content">
						<div class="line-height"><span>&nbsp;</span></div>
						<div class="detail-tilte"><p>(排名不分先后)</p></div>
						<div class="presents-box details">
		          <div class="arrow-up">&nbsp;</div>
		          <ul class="detail-votes" v-if="has_detail">
		          	<li class="votes-item" v-for="item in data.candidates">
		          		<div class="item-text">{{item.name}}</div>
		          		<div class="item-btn"><router-link :style="{backgroundColor: $store.state.config.button_color}" class="vote-btn" :to="{path: 'detail', query:{candidate_id:item.candidate_id, reward_id: $route.query.reward_id, tt: $route.query.tt, message_id: $route.query.message_id}}">详情</router-link></div>
		          		<div class="clearfix"></div>
		          	</li>
		          </ul>
		          <ul class="detail-votes" v-else>
		          	<li class="votes-item" v-for="item in data.candidates">
		          		<div class="item-text">{{item.name}}</div>
		          		<div class="item-btn"><a :style="{backgroundColor: $store.state.config.button_color}" class="vote-btn" href="javascript:;" @click="vote(item.candidate_id)">{{(count[$route.query.reward_id][item.candidate_id] == 0 || count[$route.query.reward_id][item.candidate_id] == undefined) ? '投票': '已投'+count[$route.query.reward_id][item.candidate_id]+'票'}}</a></div>
		          		<div class="clearfix"></div>
		          	</li>
		          </ul>
		        </div>
						<div class="share-box">
							<router-link :style="{backgroundColor: $store.state.config.button_color}" class="share-btn" :to="{path: 'result', query: {reward_id: $route.query.reward_id, tt: $route.query.tt, message_id: $route.query.message_id}}">查看结果</router-link>
		          <router-link :style="{backgroundColor: $store.state.config.button_color}" class="back-btn" :to="{path: '/', query: {tt: $route.query.tt, message_id: $route.query.message_id}}">返回上页</router-link>
						</div>
						<div class="rule" v-if="!has_detail">
              <p>投票规则：</p>
              <div v-html="data.strategy_info"></div>
            </div>
						<div class="footer" v-show="false"><img :src="$store.state.config.footer"></div>
            <div class="nbd-comment">
              <div class="nbd-label">
                <span>网友评论</span>
              </div>
              <div class="nbd-input">
                <input type="text" placeholder="说点什么......" v-model="value">
              </div>
              <div class="btn-comment" @click="comment"><a href="javascript:;">发布评论</a></div>
              <div class="clearfix"></div>
            </div>
						<v-comment></v-comment>
					</div>

				</div>	
			</div>
		</div>
  	<v-loading v-show="status"></v-loading>
    <v-identify v-show="$store.state.identifyStatus.status"></v-identify>
	</div>
</template>

<script>
import {ajax} from 'jquery'

import Load from '@/components/Loading'
import Identify from '@/components/Identify'
import Comment from '@/components/Comment'
import shareInfo from '@/assets/js/weixinShare.js'

export default{
	name: 'lists',
	components: {
		'v-loading': Load,
    'v-identify': Identify,
    'v-comment': Comment
	},
	data() {
		return{
			status: true,//loading状态
			has_detail: true, //是否有详情页
      title: '',
      data: {},
      count:{},
      current:'',
      value: ''
		}
	},
	created() {
		let that = this;

    document.body.scrollTop = 0;
		ajax({
			type: 'get',
			url: that.$store.state.Host+'/v/rewards/'+that.$route.query.reward_id,
			success: function (res) {
				that.has_detail = res.candidates[0].has_details;
		   	that.data = res;
		   	that.title = res.name;
				that.status = false;

				if(!that.has_detail){
					that.initStore();
				}
		  }
		});
	},
	mounted() {
		let that = this;

    setTimeout(function() {
      // 分享调用
      shareInfo.init({title:that.$store.state.config.title,desc:that.$store.state.config.share_desc,shareURL: location.href,img:that.$store.state.config.share});
    }, 2000);
	},
	methods: {
		initStore() {
			let that = this;

			let reward_id = that.$route.query.reward_id;
      //处理本地存储
      let nowTime = new Date().getDate(),
          oldTime = JSON.parse(localStorage.getItem('time')),
          newArr = [];

      //iOS上
      oldTime = !!(navigator.userAgent).match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) && (oldTime == 'null') ? null : oldTime;
      
      //固定时间间隔清除localStorage
      if(Math.abs(nowTime - oldTime) >= 1 || oldTime == null ) {
        localStorage.clear();
      }

      let count = JSON.parse(localStorage.getItem('count'));
      if(count == null) {
        var this_obj = {total: 0};
       	count = {};

        for(var i in that.data.candidates) {
        	this_obj[that.data.candidates[i]['candidate_id']] = 0;
        }
        count[reward_id] = this_obj;
        localStorage.setItem('time', JSON.stringify(nowTime));
      } else {
      	var this_obj = count[reward_id];
        if(this_obj == null) {
          this_obj = {total: 0};
          count[reward_id] = this_obj;
          for(var i in that.data.candidates) {
	        	this_obj[that.data.candidates[i]['candidate_id']] = 0;
	        }
        }
        count[reward_id] = this_obj;
      }

      that.count = count;
		},
		vote(id) {
      let that = this,
          reward_id = that.$route.query.reward_id,
          count = that.count,
          time = Date.parse(new Date())/1000;

      if(time < that.$store.state.config.start_time) {
        alert('投票还未开始！');
        return false;
      }

      if(time > that.$store.state.config.end_time) {
        alert('投票已结束！');
        return false;
      }

      if(count[reward_id][id] >= that.data.candidate_limit) {
        alert('此项您已不能再投。');
        return false;
      }

      //投票判断
      if(count[reward_id]['total'] >= that.data.reward_limit) {
        alert('此奖您已不能再投。');
        return false;
      }

      count[reward_id][id] += 1;
      count[reward_id]['total'] += 1;
      that.current = count[reward_id][id] == 0?'投票':'已投'+count[reward_id][id]+'票';
      
      //投票接口
      ajax({
      	type: 'post',
      	url: that.$store.state.Host+'/v/votings?vote_id='+that.$route.query.tt+'&reward_id='+that.$route.query.reward_id+'&candidate_id='+id,
        complete:function(res){//认证验证码
          if(res.status == 401) {
            var result = {
              url: res.responseJSON.url,
              key: res.responseJSON.key,
              refresh_url: res.responseJSON.refresh_url
            };

            that.$store.dispatch('showIdentify', {status: true, mock_height: document.body.clientHeight + 'px'});
            that.$store.dispatch('refreshImg', result);
          }
        },
      	success: function(res) {
      		localStorage.setItem('count', JSON.stringify(count));
      		console.log(res);
      	}
      });
		},
    comment() {
      let that = this;
      let name = JSON.parse(localStorage.getItem('name'));

      if(name == null) {
        name = '每经网友'+Math.round(Math.random()*999);
        localStorage.setItem('name', JSON.stringify(name));
      }

      let current_comment = {
        speaker: name,
        content: that.value
      };

      that.$store.dispatch('currentComment', current_comment);
      that.value = '';

      ajax({
        type: 'post',
        url: that.$store.state.Host+'/v/communications',
        data: {communication:{speaker:name, content:current_comment.content, message_id: 1}},
        success: function(res) {
          console.log(res);
        }
      });
    }
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/Lists.vue